import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AgendaPro, Instagram, LinkedIn, Youtube } from '@agendapro/emerald-icons';

import { GlobalContentLayout } from '@/components/';
import { Paragraph, Link } from '../../Atoms';
import * as St from './AppFooter.styles';

export const AppFooter: FC<{ className?: string }> = ({ className = '' }) => {
  const { t } = useTranslation();

  const companyLinks = [
    {
      text: t('FOOTER.LINK_1'),
      href: 'https://agendapro.com/cl',
      target: '_blank',
    },
    {
      text: t('FOOTER.LINK_2'),
      href: 'https://app.agendapro.com/sign_up',
      target: '_blank',
    },
    {
      text: t('FOOTER.LINK_3'),
      href: 'https://agendapro.com/cl/terminos-y-condiciones',
      target: '_blank',
    },
  ];

  const socialLinks = [
    { href: 'https://www.linkedin.com/company/agendapro', icon: <LinkedIn size={22} />, label: 'LinkedIn' },
    {
      href: 'https://www.instagram.com/agendapro_software/',
      icon: <Instagram size={22} />,
      label: 'Instagram',
    },
    {
      href: 'https://www.youtube.com/channel/UCoCMp3I4V5uojehS2Co0v5g',
      icon: <Youtube size={22} />,
      label: 'Youtube',
    },
  ];

  return (
    <St.Container className={className}>
      <GlobalContentLayout>
        <St.BoxWrapper>
          <St.ContentWrapper>
            <AgendaPro />
            <St.LinksWrapper>
              {companyLinks.map((_) => (
                <Link key={_.href} className="companyLink" href={_.href} size="small">
                  {_.text}
                </Link>
              ))}
            </St.LinksWrapper>
            <div>
              <St.SocialComment size="subHeadline"> {t('FOOTER.SOCIAL')}</St.SocialComment>
              <St.IconWrapper>
                {socialLinks.map((social) => (
                  <St.SocialButton target="_blank" href={social.href} key={social.href} aria-label={social.label}>
                    {social.icon}
                  </St.SocialButton>
                ))}
              </St.IconWrapper>
            </div>
          </St.ContentWrapper>
          <St.CopyrightWrapper>
            <Paragraph weight="light" size="small">
              {`${t('FOOTER.COPYRIGHT')}`}
            </Paragraph>
          </St.CopyrightWrapper>
        </St.BoxWrapper>
      </GlobalContentLayout>
    </St.Container>
  );
};
